import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/store';
import { Vertrag, VertragAnalyse, VertragItem } from '@/models/VertragModels';

export type Getters = {
  vertraege(state: State): Array<Vertrag>;
  vertragItems(state: State): Array<VertragItem>;
  vertragAnalysen(state: State): VertragAnalyse | null;
};

export const getters: GetterTree<State, RootState> & Getters = {
  vertraege(state: State): Array<Vertrag> {
    return state.vertraege;
  },
  vertragItems(state: State): Array<VertragItem> {
    return state.vertragItems;
  },
  vertragAnalysen(state: State): VertragAnalyse | null {
    return state.vertragAnalysen;
  },
};
